import { SearchBar } from '@components/inputs/SearchBar';
import { type SearchBarProps } from '@components/inputs/SearchBar/SearchBar';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CardContainerTitleSeeAllProps {
  title: string;
  redirect?: string;
  enableSearchBar?: boolean;
  searchBarOptions?: SearchBarProps;
}

const CardContainerTitleSeeAll: FC<CardContainerTitleSeeAllProps> = ({
  title,
  redirect,
  enableSearchBar,
  searchBarOptions,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full justify-between items-center mt-2 mb-4 text-gray-60">
      <h3 className="font-bold uppercase">{title}</h3>
      <div className="flex gap-4 items-center">
        {enableSearchBar && (
          <div className="flex gap-4 items-center">
            <SearchBar {...searchBarOptions} />
            <span className="h-[13px] w-[1px] bg-gray-30 rounded mr-3" />
          </div>
        )}
        <Link
          to={redirect ?? '#'}
          className="text-base mr-6 text-tertiary-dark"
        >
          {t('common.seeAll')}
        </Link>
      </div>
    </div>
  );
};
export default CardContainerTitleSeeAll;
